var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPie3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6994 24.2295V27.2688L28.0078 29.4806V26.4413L52.6994 24.2295Z",
    fill: "#639CD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33984 31.8871V34.9264L28.0072 29.4807V26.4414L4.33984 31.8871Z",
    fill: "#D84367"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 8.84229V11.8816L28.007 29.4807V26.4414L28.002 8.84229Z",
    fill: "#639CD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3507 41.2978V44.3371L28.0078 29.4807V26.4414L41.3507 41.2978Z",
    fill: "#2A2A2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 8.84229C40.6468 8.84046 51.1094 15.3592 52.6986 24.2296V27.2689C51.1094 18.3985 40.6468 11.8798 28.002 11.8816V8.84229Z",
    fill: "#639CD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9961 8.84229V11.8816L28.006 29.4807V26.4414L27.9961 8.84229Z",
    fill: "#D84367"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9648 39.2679V42.3073L28.0065 29.4807V26.4414L10.9648 39.2679Z",
    fill: "#676CD0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33867 31.8871C3.48683 30.036 3.11719 28.388 3.11719 26.4414V29.4807C3.11719 19.7635 14.2539 11.8855 27.9961 11.8816V8.84229C14.2539 8.84616 3.11719 16.7241 3.11719 26.4414V29.4807C3.11719 31.4273 3.48683 33.0753 4.33867 34.9264V31.8871Z",
    fill: "#4C7BDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33984 31.8872V34.9266L28.0072 29.4807V26.4414L4.33984 31.8872Z",
    fill: "#676CD0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3496 43.7297V46.7691L28.0062 29.4807V26.4414L23.3496 43.7297Z",
    fill: "#DE8A43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9655 39.2679C7.76397 37.141 5.69915 34.8409 4.33984 31.8872V34.9265C5.69915 37.8803 7.76397 40.1804 10.9655 42.3072V39.2679Z",
    fill: "#4C7BDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6994 24.23V27.2693L28.0078 29.4809V26.4416L52.6994 24.23Z",
    fill: "#2A2A2F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8956 26.4414C52.8956 32.66 48.7735 37.964 41.3496 41.2978V44.3371C48.7735 41.0033 52.8956 35.6994 52.8956 29.4807V26.4414Z",
    fill: "#8377CB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9648 39.2681V42.3074L28.0063 29.4807V26.4414L10.9648 39.2681Z",
    fill: "#88CBF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5867 43.6936C18.6336 43.0356 14.6534 41.6213 10.9785 39.2134V42.2653C14.6534 44.6733 18.6336 46.0876 23.5867 46.7455V43.6936Z",
    fill: "#4C7BDB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5126 41.2979C35.9428 43.799 29.9952 44.6026 23.5137 43.7297V46.769C29.9952 47.6419 35.9428 46.8383 41.5126 44.3372V41.2979Z",
    fill: "#7CC5D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 8.84229C40.6468 8.84046 51.1094 15.3592 52.6986 24.2296L28.007 26.4414L28.002 8.84229Z",
    fill: "#FF878B",
    stroke: "#FF878B",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6994 24.23C53.9431 31.1728 49.7054 37.5462 41.3507 41.298L28.0078 26.4416L52.6994 24.23Z",
    fill: "#9E8FE9",
    stroke: "#9E8FE9",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5126 41.2979C35.9428 43.799 29.9952 44.6026 23.5137 43.7298L28.17 26.4414L41.5126 41.2979Z",
    fill: "#7AE0EE",
    stroke: "#7AE0EE",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3497 43.7297C18.4843 43.0745 14.5746 41.666 10.9648 39.2681L28.0063 26.4414L23.3497 43.7297Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9655 39.2679C7.76397 37.1411 5.69915 34.841 4.33984 31.8872L28.0072 26.4414L10.9655 39.2679Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33953 31.8871C0.0861981 22.6444 7.23444 12.7136 20.3056 9.706C22.9201 9.10442 25.2476 8.84306 27.997 8.84229L28.0069 26.4414L4.33953 31.8871Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie3D);
export default __webpack_public_path__ + "static/media/pie3d.7888011eaf00e21edda08a780bd4adf8.svg";
export { ForwardRef as ReactComponent };